/* istanbul ignore file */
import {
  paymentsFeatureDefaultValue,
  paymentsFeatureName,
} from 'core/feature-flags/config/paymentsFeature';
import { useFeatureFlags } from 'core/feature-flags/hooks';

export const usePaymentMethodsConfig = () => {
  const featureFlags = useFeatureFlags();

  const paymentMethods = featureFlags.getFeatureValue(
    paymentsFeatureName,
    paymentsFeatureDefaultValue,
  );

  return paymentMethods;
};
